export default __webpack_public_path__ + "static/media/093-expand-1.c7b6270e.png";